import React, { useState, useEffect, useRef, useCallback } from 'react';

import axios from 'axios';

import API_URL from '../../config/api';

import { CheckCircle, ChefHat, Clock, Volume2, VolumeX, RefreshCw, Timer, Mic, MicOff, ShoppingBag, Utensils, X, MapPin } from 'lucide-react';

import { toEcuadorTime, formatEcuadorTime, getEcuadorDateStr, getOrderCode } from '../../utils/ecuadorTime';

// ⭐ SONIDOS DE COCINA - 10 opciones con Web Audio API

const KITCHEN_SOUNDS = [

 { id: 'beep_triple', label: ' 3 Beeps suaves', play: (ctx) => {

 [0, 0.3, 0.6].forEach(delay => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.value = 660; o.type = 'sine';

 g.gain.setValueAtTime(0.25, ctx.currentTime + delay);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + 0.25);

 o.start(ctx.currentTime + delay); o.stop(ctx.currentTime + delay + 0.28);

 });

 }},

 { id: 'ding', label: ' Ding simple', play: (ctx) => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.value = 880; o.type = 'sine';

 g.gain.setValueAtTime(0.3, ctx.currentTime);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.8);

 o.start(ctx.currentTime); o.stop(ctx.currentTime + 0.8);

 }},

 { id: 'double_ding', label: ' Doble Ding', play: (ctx) => {

 [0, 0.5].forEach(delay => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.value = delay === 0 ? 660 : 880; o.type = 'sine';

 g.gain.setValueAtTime(0.3, ctx.currentTime + delay);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + 0.6);

 o.start(ctx.currentTime + delay); o.stop(ctx.currentTime + delay + 0.6);

 });

 }},

 { id: 'soft_chime', label: ' Campana suave', play: (ctx) => {

 [0, 0.2, 0.4].forEach((delay, i) => {

 const freqs = [523, 659, 784];

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.value = freqs[i]; o.type = 'sine';

 g.gain.setValueAtTime(0.2, ctx.currentTime + delay);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + 0.5);

 o.start(ctx.currentTime + delay); o.stop(ctx.currentTime + delay + 0.5);

 });

 }},

 { id: 'pop', label: ' Pop discreto', play: (ctx) => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.setValueAtTime(200, ctx.currentTime);

 o.frequency.exponentialRampToValueAtTime(100, ctx.currentTime + 0.1);

 o.type = 'sine';

 g.gain.setValueAtTime(0.4, ctx.currentTime);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);

 o.start(ctx.currentTime); o.stop(ctx.currentTime + 0.12);

 }},

 { id: 'wood_knock', label: ' Golpe madera', play: (ctx) => {

 [0, 0.2].forEach(delay => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.setValueAtTime(300, ctx.currentTime + delay);

 o.frequency.exponentialRampToValueAtTime(80, ctx.currentTime + delay + 0.15);

 o.type = 'triangle';

 g.gain.setValueAtTime(0.5, ctx.currentTime + delay);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + 0.15);

 o.start(ctx.currentTime + delay); o.stop(ctx.currentTime + delay + 0.15);

 });

 }},

 { id: 'marimba', label: ' Marimba', play: (ctx) => {

 [0, 0.25, 0.5, 0.75].forEach((delay, i) => {

 const freqs = [523, 659, 784, 1047];

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.value = freqs[i]; o.type = 'triangle';

 g.gain.setValueAtTime(0.25, ctx.currentTime + delay);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + 0.4);

 o.start(ctx.currentTime + delay); o.stop(ctx.currentTime + delay + 0.4);

 });

 }},

 { id: 'gentle_bell', label: ' Cascabel gentil', play: (ctx) => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.value = 1047; o.type = 'sine';

 g.gain.setValueAtTime(0.15, ctx.currentTime);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 1.5);

 o.start(ctx.currentTime); o.stop(ctx.currentTime + 1.5);

 }},

 { id: 'ping', label: ' Ping digital', play: (ctx) => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.setValueAtTime(1200, ctx.currentTime);

 o.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.1);

 o.type = 'sine';

 g.gain.setValueAtTime(0.2, ctx.currentTime);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);

 o.start(ctx.currentTime); o.stop(ctx.currentTime + 0.3);

 }},

 { id: 'whistle', label: ' Silbido corto', play: (ctx) => {

 const o = ctx.createOscillator(); const g = ctx.createGain();

 o.connect(g); g.connect(ctx.destination);

 o.frequency.setValueAtTime(900, ctx.currentTime);

 o.frequency.setValueAtTime(1100, ctx.currentTime + 0.1);

 o.frequency.setValueAtTime(900, ctx.currentTime + 0.2);

 o.type = 'sine';

 g.gain.setValueAtTime(0.2, ctx.currentTime);

 g.gain.setValueAtTime(0.2, ctx.currentTime + 0.2);

 g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);

 o.start(ctx.currentTime); o.stop(ctx.currentTime + 0.35);

 }}

];



const playSound = (soundId) => {

 try {

 const AudioContext = window.AudioContext || window.webkitAudioContext;

 if (!AudioContext) return;

 const ctx = new AudioContext();

 const sound = KITCHEN_SOUNDS.find(s => s.id === soundId) || KITCHEN_SOUNDS[0];

 sound.play(ctx);

 } catch (e) {

 console.log('Audio no disponible');

 }

};



// ⭐ OBTENER TIMER PROGRESIVO: pedido #n en cola tiene baseTimer + (n-1)*extraMinutes

const getProgressiveTimer = (orderIndex, baseTimer, extraMinutes) => {

 return baseTimer + orderIndex * extraMinutes;

};



// ⭐ COMANDO DE VOZ: extraer numero de pedido + accion de una frase tipo
// "orden 2 lista" (marcar listo) o "cancela la orden 3" / "anula el pedido 3" (cancelar)
const VOICE_NUMBER_WORDS = {
 uno: 1, una: 1, dos: 2, tres: 3, cuatro: 4, cinco: 5, seis: 6, siete: 7,
 ocho: 8, nueve: 9, diez: 10, once: 11, doce: 12, trece: 13, catorce: 14,
 quince: 15, dieciseis: 16, diecisiete: 17, dieciocho: 18, diecinueve: 19, veinte: 20
};

const VOICE_CANCEL_WORDS = /(cancela|cancelar|cancelada|cancelado|anula|anular|anulada|anulado)/;
const VOICE_DONE_WORDS = /(listo|lista|listos|listas|sali[oó]|termin[oó]|complet[oa])/;

const extractVoiceCommand = (transcript) => {
 const text = (transcript || '').toLowerCase().trim();

 // Se revisa "cancelar" primero: es la palabra mas especifica y evita que una
 // frase como "cancela la orden 2" se confunda con "listo/lista" por error.
 let action = null;
 if (VOICE_CANCEL_WORDS.test(text)) action = 'cancel';
 else if (VOICE_DONE_WORDS.test(text)) action = 'done';
 if (!action) return null;

 let orderNumber = null;
 const digitMatch = text.match(/(?:orden|pedido|comanda|n[uú]mero)\s*(?:n[uú]mero\s*)?(\d{1,3})/);
 if (digitMatch) {
   orderNumber = parseInt(digitMatch[1], 10);
 } else {
   const words = text.split(/\s+/);
   for (const w of words) {
     if (VOICE_NUMBER_WORDS[w] != null) { orderNumber = VOICE_NUMBER_WORDS[w]; break; }
   }
 }
 if (orderNumber == null) return null;

 return { orderNumber, action };
};



// ⭐ FORMATEAR TIEMPO EXTRA (después de pasar el timer)

const formatOvertime = (seconds) => {

 if (seconds <= 0) return null;

 const m = Math.floor(seconds / 60);

 const s = seconds % 60;

 return `+${m}:${String(s).padStart(2, '0')}`;

};



// ⭐ TIMER CARD

const KitchenCard = ({ order, orderIndex, kitchenTimer, extraMinutes, onMarkDone, onMarkCancelled }) => {

 const progressiveTimer = getProgressiveTimer(orderIndex, kitchenTimer, extraMinutes);

 const items = Array.isArray(order.items) ? order.items : JSON.parse(order.items || '[]');



 const getElapsedSeconds = useCallback(() => {

 const startTime = order.kitchen_started_at

 ? toEcuadorTime(order.kitchen_started_at)

 : toEcuadorTime(order.created_at);

 return Math.floor((new Date() - startTime) / 1000);

 }, [order]);



 const totalSeconds = progressiveTimer * 60;

 const [elapsed, setElapsed] = useState(getElapsedSeconds());



 useEffect(() => {

 const interval = setInterval(() => setElapsed(getElapsedSeconds()), 1000);

 return () => clearInterval(interval);

 }, [getElapsedSeconds]);



 const remaining = Math.max(0, totalSeconds - elapsed);

 const overtime = elapsed > totalSeconds ? elapsed - totalSeconds : 0;

 const progress = Math.min(1, elapsed / totalSeconds);



 const mins = Math.floor(remaining / 60);

 const secs = remaining % 60;

 const timeStr = remaining > 0 ? `${mins}:${String(secs).padStart(2, '0')}` : '⏰';



 const getTimerColor = () => {

 if (remaining <= 0) return { bg: 'bg-red-600', border: 'border-red-500', ring: '#ef4444', label: ' URGENTE' };

 if (remaining <= 120) return { bg: 'bg-red-500', border: 'border-red-400', ring: '#ef4444', label: ' URGENTE' };

 if (progress >= 0.5) return { bg: 'bg-yellow-500', border: 'border-yellow-400', ring: '#f59e0b', label: ' ATENCIN' };

 return { bg: 'bg-green-500', border: 'border-green-400', ring: '#10b981', label: ' EN TIEMPO' };

 };



 const colors = getTimerColor();

 // ⭐ day_order_number viene calculado del backend (sobre TODAS las ventas
 // del día, no solo activas) -- getOrderCode es la fuente única compartida.
 const dayCode = getOrderCode(order);

 const tableName = order.table_name || (order.table_id ? `Mesa ${order.table_id}` : null);



 return (

 <div className={`bg-white rounded-2xl shadow-lg border-2 ${colors.border} overflow-hidden ${remaining <= 0 ? 'animate-pulse' : ''}`}>

 <div className={`${colors.bg} p-4`}>

 <div className="flex justify-between items-start">

 <div>

 <span className="text-2xl font-black text-white">{dayCode}</span>

 {orderIndex > 0 && (

 <span className="ml-2 bg-white/20 text-white text-xs px-2 py-0.5 rounded-full">

 ⏱ {progressiveTimer}min

 </span>

 )}

 </div>

 <div className="text-right">

 <div className="text-white/90 text-xs">{formatEcuadorTime(order.created_at)}</div>

 <div className="mt-1 flex flex-col items-end gap-1">

 <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-black shadow-sm ${order.order_type === 'llevar' ? 'bg-amber-900 text-white' : 'bg-blue-900 text-white'}`}>

 {order.order_type === 'llevar' ? <ShoppingBag className="w-3.5 h-3.5" /> : <Utensils className="w-3.5 h-3.5" />}

 {order.order_type === 'llevar' ? 'PARA LLEVAR' : 'SERVIR EN MESA'}

 </span>

 {/* ⭐ Fix de visibilidad (pedido de Angelo, 2026-08-05): antes esto era
 texto blanco semitransparente (text-white/90) sin fondo -- se perdía
 contra el header de color, justo cuando es el dato que le dice al mesero
 A QUÉ MESA llevar el plato. Mismo tratamiento de badge sólido que ya
 tiene el tipo de pedido arriba (ver fix #88), así resalta igual de bien
 sin importar si el header está verde/amarillo/rojo. */}
 {tableName && (
 <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-black shadow-sm bg-white text-gray-900">
 <MapPin className="w-3.5 h-3.5" />
 {tableName}
 </span>
 )}

 </div>

 </div>

 </div>

 {order.customer_name && (

 <div className="mt-2 text-white/90 text-sm font-semibold"> {order.customer_name}</div>

 )}

 </div>



 <div className="flex justify-center py-4">

 <div className="relative w-28 h-28">

 <svg className="w-28 h-28 -rotate-90" viewBox="0 0 100 100">

 <circle cx="50" cy="50" r="44" fill="none" stroke="#e5e7eb" strokeWidth="8" />

 <circle

 cx="50" cy="50" r="44" fill="none"

 stroke={colors.ring} strokeWidth="8"

 strokeDasharray={`${Math.PI * 2 * 44}`}

 strokeDashoffset={`${Math.PI * 2 * 44 * progress}`}

 strokeLinecap="round" className="transition-all duration-1000"

 />

 </svg>

 <div className="absolute inset-0 flex flex-col items-center justify-center">

 <span className={`text-2xl font-black ${remaining <= 0 ? 'text-red-600' : remaining <= 120 ? 'text-red-500' : progress >= 0.5 ? 'text-yellow-600' : 'text-green-600'}`}>

 {timeStr}

 </span>

 {remaining <= 0 && overtime > 0 && (

 <span className="text-red-500 text-xs font-black animate-pulse">

 {formatOvertime(overtime)}

 </span>

 )}

 </div>

 </div>

 </div>



 <div className="px-4 pb-3">

 <div className="space-y-1 max-h-36 overflow-y-auto">

 {items.map((item, idx) => (

 <div key={idx} className="flex items-center gap-2 py-1 border-b border-gray-100 last:border-0">

 <span className="bg-gray-800 text-white font-black px-2.5 py-1 rounded-lg text-sm flex-shrink-0">x{item.quantity}</span>

 <span className="font-bold text-gray-800 text-sm">{item.name}</span>

 </div>

 ))}

 </div>

 </div>



 <div className="flex gap-2 p-3 border-t bg-gray-50">

 <button

 onClick={() => onMarkDone(order.id, overtime, progressiveTimer)}

 className="flex-1 py-2.5 bg-green-600 text-white font-bold rounded-xl hover:bg-green-700 transition flex items-center justify-center gap-2 text-sm"

 >

 <CheckCircle className="w-4 h-4" />

 Listo 

 </button>

 <button

 onClick={() => onMarkCancelled(order.id)}

 className="px-3 py-2.5 bg-red-100 text-red-700 font-bold rounded-xl hover:bg-red-200 transition text-sm"

 >

 

 </button>

 </div>

 </div>

 );

};



// ============================================

// COMPONENTE PRINCIPAL: CocinaDisplay

// ============================================

function CocinaDisplay({ token }) {

 const [orders, setOrders] = useState([]);

 const [loading, setLoading] = useState(true);

 const [alert, setAlert] = useState(null);
 const [confirmCancel, setConfirmCancel] = useState(null);

 // ⭐ FIX: la alerta de arriba a la derecha (pedido listo, comando de voz,
 // errores) no tenia auto-cierre y su boton de cerrar era un caracter que
 // no renderizaba en algunos dispositivos (practicamente invisible/imposible
 // de tocar en celular) -- quedaba pegada hasta recargar la pestaña. Ahora
 // se autocierra sola a los 6s, y el boton de cerrar es un icono real con
 // area de toque de sobra.
 useEffect(() => {
 if (!alert) return;
 const timer = setTimeout(() => setAlert(null), 6000);
 return () => clearTimeout(timer);
 }, [alert]);



 // ⭐ REFS para evitar stale closure bugs

 const soundEnabledRef = useRef(localStorage.getItem('pos_kitchen_sound') !== 'false');

 const selectedSoundRef = useRef(localStorage.getItem('pos_kitchen_selected_sound') || 'beep_triple');

 const knownOrderIdsRef = useRef(null); // null = primera carga (no hacer beep)

 const doneOrderIdsRef = useRef(new Set()); // IDs marcados como listos (para no re-mostrar)



 // ⭐ State para UI (derivado de refs donde sea necesario)

 const [soundEnabled, setSoundEnabled] = useState(soundEnabledRef.current);

 const [selectedSound, setSelectedSound] = useState(selectedSoundRef.current);

 const [showSoundMenu, setShowSoundMenu] = useState(false);



 // ⭐ Config: timer base y tiempo extra entre pedidos

 const [kitchenTimer] = useState(parseInt(localStorage.getItem('pos_kitchen_timer') || '7'));

 const [extraMinutes] = useState(parseFloat(localStorage.getItem('pos_kitchen_extra_minutes') || '1.5'));



 // ⭐ Comando de voz: "orden 2 lista" marca esa comanda como lista automaticamente,
 // SIN pedir confirmacion (asi se pidio explicitamente). Riesgo real en cocina con
 // ruido: puede marcar una comanda equivocada; no hay boton para "reabrir" una
 // comanda ya marcada lista. Se activa manualmente cada sesion (no se persiste
 // encendido entre recargas) para que nunca quede el microfono escuchando sin que
 // alguien lo haya prendido a proposito.
 const voiceSupported = typeof window !== 'undefined' && !!(window.SpeechRecognition || window.webkitSpeechRecognition);
 const [voiceEnabled, setVoiceEnabled] = useState(false);
 const voiceEnabledRef = useRef(false);
 const recognitionRef = useRef(null);
 const ordersRef = useRef([]);



 // ⭐ doneOrders: persistidos en localStorage por día

 const todayStr = getEcuadorDateStr(new Date().toISOString());

 const loadDoneOrders = () => {

 try {

 const saved = localStorage.getItem(`pos_done_orders_${todayStr}`);

 return saved ? JSON.parse(saved) : [];

 } catch { return []; }

 };

 const [doneOrders, setDoneOrders] = useState(loadDoneOrders);



 // Al montar, cargar IDs de pedidos ya marcados como listos para no mostrarlos

 useEffect(() => {

 const saved = loadDoneOrders();

 doneOrderIdsRef.current = new Set(saved.map(o => o.id));

 }, []);



 const saveDoneOrders = (orders) => {

 localStorage.setItem(`pos_done_orders_${todayStr}`, JSON.stringify(orders));

 };



 const showAlert = (type, title, message) => setAlert({ type, title, message });



 const loadOrders = useCallback(async () => {

 try {

 // ⭐ Usar endpoint dedicado de cocina — filtra en SQL (más robusto)

 const response = await axios.get(`${API_URL}/api/pos/kitchen-orders`, {

 headers: { Authorization: `Bearer ${token}` }

 });



 // Solo excluir los marcados como listos en esta sesión local

 const active = response.data.filter(s =>

 !doneOrderIdsRef.current.has(s.id)

 );



 // ⭐ Detectar NUEVOS pedidos (no en primera carga)

 if (knownOrderIdsRef.current !== null) {

 const newOrders = active.filter(o => !knownOrderIdsRef.current.has(o.id));

 if (newOrders.length > 0 && soundEnabledRef.current) {

 playSound(selectedSoundRef.current);

 }

 }



 // Actualizar set de IDs conocidos

 knownOrderIdsRef.current = new Set(active.map(o => o.id));



 setOrders(active);

 } catch (error) {

 console.error('Error al cargar pedidos cocina:', error);

 } finally {

 setLoading(false);

 }

 }, [token]);



 useEffect(() => {

 loadOrders();

 const interval = setInterval(loadOrders, 8000);

 return () => clearInterval(interval);

 }, [loadOrders]);



 const handleMarkDone = (orderId, overtimeSeconds, estimatedMinutes) => {

 const order = orders.find(o => o.id === orderId);

 if (!order) return;



 // ⭐ Marcar como listo en la BD para que persista entre deploys
 // estimated_minutes: tiempo estimado (base + buffer de cola) vigente para ESTA
 // comanda al momento de marcarla lista, para poder comparar real vs estimado en Reportes.
 axios.post(`${API_URL}/api/pos/sales/${orderId}/kitchen-done`, { overtime_seconds: overtimeSeconds || 0, estimated_minutes: estimatedMinutes || null }, {
   headers: { Authorization: `Bearer ${token}` }
 }).catch(err => console.error('Error marcando kitchen-done:', err));

 // ⭐ Agregar ID al Set de listos para que no vuelva a aparecer

 doneOrderIdsRef.current.add(orderId);



 // ⭐ Agregar al historial del día y guardar en localStorage

 const doneEntry = {

 ...order,

 done_at: new Date().toISOString(),

 overtime_seconds: overtimeSeconds || 0

 };

 const newDoneOrders = [...doneOrders, doneEntry];

 setDoneOrders(newDoneOrders);

 saveDoneOrders(newDoneOrders);



 // ⭐ Quitar del estado de activos

 setOrders(prev => prev.filter(o => o.id !== orderId));



 const code = getOrderCode(order);

 const overtimeStr = overtimeSeconds > 0 ? ` (+${Math.ceil(overtimeSeconds / 60)} min extra)` : '';

 showAlert('success', '¡Pedido Listo!', ` Pedido ${code} marcado como listo${overtimeStr}`);

 };



 // ⭐ Mantener siempre accesible la lista de comandas activas actual dentro del
 // handler de reconocimiento de voz (que se crea una sola vez, no en cada render).
 useEffect(() => {
   ordersRef.current = orders;
 }, [orders]);

 // ⭐ FIX: handleVoiceCommand vive dentro de un useCallback con deps fijas
 // ([kitchenTimer, extraMinutes], que nunca cambian), asi que se crea UNA sola
 // vez y quedaba con una referencia congelada a handleMarkDone tal como era en
 // el primer render (cerrada sobre `orders` vacio de ese momento). Resultado:
 // la alerta de voz se mostraba igual, pero por dentro handleMarkDone no
 // encontraba la orden (orders=[] en ese closure viejo) y no hacia nada — ni
 // llamaba al backend ni quitaba la tarjeta ni detenia el cronometro. Se
 // arregla llamando siempre a la version mas reciente via un ref.
 const handleMarkDoneRef = useRef(handleMarkDone);
 useEffect(() => {
   handleMarkDoneRef.current = handleMarkDone;
 });

 // ⭐ executeCancel se declara mas abajo en el componente; se inicializa el ref
 // en null (no como useRef(executeCancel), que fallaria por orden de declaracion)
 // y se sincroniza en cada render via el useEffect sin dependencias.
 const executeCancelRef = useRef(null);
 useEffect(() => {
   executeCancelRef.current = executeCancel;
 });

 const handleVoiceCommand = useCallback((orderNumber, action) => {
   const activeOrders = ordersRef.current || [];
   const match = activeOrders.find(o => Number(o.day_order_number) === orderNumber);
   if (!match) return;

   if (action === 'cancel') {
     if (executeCancelRef.current) executeCancelRef.current(match.id);
     showAlert('error', ' Comando de Voz', `Orden ${orderNumber} cancelada por voz`);
     return;
   }

   const orderIndex = match.kitchen_queue_position != null ? match.kitchen_queue_position : 0;
   const progressiveTimer = getProgressiveTimer(orderIndex, kitchenTimer, extraMinutes);
   const startTime = match.kitchen_started_at ? toEcuadorTime(match.kitchen_started_at) : toEcuadorTime(match.created_at);
   const elapsed = Math.floor((new Date() - startTime) / 1000);
   const overtime = Math.max(0, elapsed - progressiveTimer * 60);

   handleMarkDoneRef.current(match.id, overtime, progressiveTimer);
   showAlert('success', ' Comando de Voz', `Orden ${orderNumber} marcada como lista por voz`);
   // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [kitchenTimer, extraMinutes]);

 // ⭐ Reconocimiento de voz (Web Speech API) — se activa/desactiva manualmente con
 // el boton del micrófono. Solo Chrome/Edge lo soportan de forma confiable.
 useEffect(() => {
   voiceEnabledRef.current = voiceEnabled;
   if (!voiceEnabled || !voiceSupported) return undefined;

   const SpeechRecognitionCtor = window.SpeechRecognition || window.webkitSpeechRecognition;
   const recognition = new SpeechRecognitionCtor();
   recognition.lang = 'es-ES';
   recognition.continuous = true;
   recognition.interimResults = false;

   recognition.onresult = (event) => {
     const lastResult = event.results[event.results.length - 1];
     const transcript = lastResult && lastResult[0] ? lastResult[0].transcript : '';
     const command = extractVoiceCommand(transcript);
     if (command) handleVoiceCommand(command.orderNumber, command.action);
   };

   recognition.onerror = (event) => {
     console.error('Error de reconocimiento de voz:', event.error);
     if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
       setVoiceEnabled(false);
     }
   };

   recognition.onend = () => {
     // Los navegadores cortan el reconocimiento tras un rato de silencio;
     // si el usuario no lo apago manualmente, se reinicia solo.
     if (voiceEnabledRef.current) {
       try { recognition.start(); } catch (_) { /* ya esta iniciado */ }
     }
   };

   try {
     recognition.start();
     recognitionRef.current = recognition;
   } catch (err) {
     console.error('No se pudo iniciar el reconocimiento de voz:', err);
   }

   return () => {
     recognition.onend = null;
     try { recognition.stop(); } catch (_) { /* ya estaba detenido */ }
     recognitionRef.current = null;
   };
 }, [voiceEnabled, voiceSupported, handleVoiceCommand]);



 const handleMarkCancelled = (orderId) => {
 const order = orders.find(o => o.id === orderId);
 if (!order) return;
 setConfirmCancel({ orderId, code: getOrderCode(order) });
 };

 const executeCancel = async (orderId) => {
 setConfirmCancel(null);
 try {
 await axios.post(
 `${API_URL}/api/pos/sales/${orderId}/cancel`,
 { reason: 'Anulado desde cocina' },
 { headers: { Authorization: `Bearer ${token}` } }
 );
 doneOrderIdsRef.current.add(orderId);
 setOrders(prev => prev.filter(o => o.id !== orderId));
 showAlert('error', 'Pedido Anulado', `Pedido #${orderId} anulado desde cocina`);
 } catch (error) {
 showAlert('error', 'Error', 'No se pudo anular el pedido');
 }
 };



 const handleToggleSound = () => {

 const newVal = !soundEnabledRef.current;

 soundEnabledRef.current = newVal;

 setSoundEnabled(newVal);

 localStorage.setItem('pos_kitchen_sound', newVal.toString());

 };



 const handleSelectSound = (soundId) => {

 selectedSoundRef.current = soundId;

 setSelectedSound(soundId);

 localStorage.setItem('pos_kitchen_selected_sound', soundId);

 setShowSoundMenu(false);

 // Reproducir preview

 playSound(soundId);

 };



 // Ordenar: más urgentes primero (más tiempo transcurrido)

 const sortedOrders = [...orders].sort((a, b) =>

 new Date(a.created_at) - new Date(b.created_at)

 );



 return (

 <div className="space-y-4">

 {/* Confirm cancel modal */}
 {confirmCancel && (
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
 <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6">
 <h3 className="text-lg font-bold text-gray-900 mb-2">Anular pedido</h3>
 <p className="text-gray-600 text-sm mb-6">
 ¿Seguro que deseas anular el <strong>Pedido {confirmCancel.code}</strong>? Esta acción no se puede deshacer.
 </p>
 <div className="flex gap-3">
 <button onClick={() => setConfirmCancel(null)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">Cancelar</button>
 <button onClick={() => executeCancel(confirmCancel.orderId)} className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold">Anular</button>
 </div>
 </div>
 </div>
 )}

 {/* Alert */}

 {alert && (

 <div className={`fixed top-4 right-4 z-[80] max-w-sm w-full shadow-2xl rounded-xl p-4 border-2 flex items-start gap-3 ${

 alert.type === 'success' ? 'bg-green-50 border-green-500' :

 alert.type === 'error' ? 'bg-red-50 border-red-500' :

 'bg-yellow-50 border-yellow-500'

 }`}>

 <span className="text-2xl">{alert.type === 'success' ? '' : alert.type === 'error' ? '' : '️'}</span>

 <div className="flex-1">

 <p className="font-bold text-gray-800">{alert.title}</p>

 <p className="text-sm text-gray-600">{alert.message}</p>

 </div>

 <button onClick={() => setAlert(null)} className="flex-shrink-0 p-2 -m-2 text-gray-400 hover:text-gray-600 active:text-gray-800 rounded-full touch-manipulation" aria-label="Cerrar"><X className="w-5 h-5" /></button>

 </div>

 )}



 {/* Header */}

 <div className="bg-white rounded-2xl shadow-md p-5">

 <div className="flex items-center justify-between flex-wrap gap-4">

 <div className="flex items-center gap-3">

 <div className="p-3 bg-orange-100 rounded-xl">

 <ChefHat className="w-8 h-8 text-orange-600" />

 </div>

 <div>

 <h1 className="text-2xl font-black text-gray-900"> Pantalla de Cocina</h1>

 <p className="text-sm text-gray-500">

 {sortedOrders.length} pedido{sortedOrders.length !== 1 ? 's' : ''} activo{sortedOrders.length !== 1 ? 's' : ''} · Timer base: {kitchenTimer} min · Extra: +{extraMinutes} min/pedido

 </p>

 </div>

 </div>



 <div className="flex items-center gap-3 relative">

 {/* Sonido toggle */}

 <button

 onClick={handleToggleSound}

 className={`flex items-center gap-2 px-4 py-2 rounded-xl font-semibold transition ${

 soundEnabled ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'

 }`}

 >

 {soundEnabled ? <Volume2 className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}

 {soundEnabled ? 'Sonido ON' : 'Sonido OFF'}

 </button>



 {/* Comando de voz toggle */}

 <button

 onClick={() => voiceSupported && setVoiceEnabled(v => !v)}

 disabled={!voiceSupported}

 title={voiceSupported ? 'Di "orden 2 lista" para marcarla, o "cancela la orden 2" para anularla' : 'Tu navegador no soporta reconocimiento de voz'}

 className={`flex items-center gap-2 px-4 py-2 rounded-xl font-semibold transition ${

 !voiceSupported ? 'bg-gray-50 text-gray-300 cursor-not-allowed' :

 voiceEnabled ? 'bg-red-100 text-red-700 hover:bg-red-200 animate-pulse' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'

 }`}

 >

 {voiceEnabled ? <Mic className="w-5 h-5" /> : <MicOff className="w-5 h-5" />}

 {voiceEnabled ? 'Voz ON' : 'Voz OFF'}

 </button>



 {/* Selector de sonido */}

 <div className="relative">

 <button

 onClick={() => setShowSoundMenu(!showSoundMenu)}

 className="flex items-center gap-2 px-3 py-2 bg-orange-100 text-orange-700 rounded-xl font-semibold hover:bg-orange-200 transition text-sm"

 >

 {KITCHEN_SOUNDS.find(s => s.id === selectedSound)?.label || 'Seleccionar'}

 </button>

 {showSoundMenu && (

 <div className="absolute right-0 top-12 z-50 bg-white border-2 border-orange-200 rounded-xl shadow-xl w-56 overflow-hidden">

 {KITCHEN_SOUNDS.map(sound => (

 <button

 key={sound.id}

 onClick={() => handleSelectSound(sound.id)}

 className={`w-full text-left px-4 py-3 text-sm hover:bg-orange-50 transition border-b border-gray-100 last:border-0 ${

 selectedSound === sound.id ? 'bg-orange-50 font-bold text-orange-700' : 'text-gray-700'

 }`}

 >

 {sound.label}

 {selectedSound === sound.id && ' '}

 </button>

 ))}

 </div>

 )}

 </div>



 {/* Refresh manual */}

 <button

 onClick={loadOrders}

 className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition"

 >

 <RefreshCw className="w-5 h-5" />

 </button>

 </div>

 </div>



 {/* Leyenda colores */}

 <div className="flex gap-4 mt-4 flex-wrap">

 <div className="flex items-center gap-2 text-sm">

 <div className="w-4 h-4 rounded-full bg-green-500"></div>

 <span className="text-gray-600"> En tiempo</span>

 </div>

 <div className="flex items-center gap-2 text-sm">

 <div className="w-4 h-4 rounded-full bg-yellow-500"></div>

 <span className="text-gray-600"> Más de la mitad</span>

 </div>

 <div className="flex items-center gap-2 text-sm">

 <div className="w-4 h-4 rounded-full bg-red-500"></div>

 <span className="text-gray-600"> Menos 2min / Pasado</span>

 </div>

 <div className="flex items-center gap-2 text-sm text-purple-600">

 <Timer className="w-4 h-4" />

 <span>Timer progresivo: P1={kitchenTimer}min, P2={kitchenTimer + extraMinutes}min...</span>

 </div>

 <div className="ml-auto flex items-center gap-2 text-sm text-gray-500">

 <Clock className="w-4 h-4" />

 Se actualiza cada 8 segundos

 </div>

 </div>

 </div>



 {/* Pedidos activos */}

 {loading ? (

 <div className="text-center py-12">

 <div className="animate-spin w-12 h-12 border-4 border-orange-600 border-t-transparent rounded-full mx-auto mb-4"></div>

 <p className="text-gray-500">Cargando pedidos...</p>

 </div>

 ) : sortedOrders.length === 0 ? (

 <div className="bg-white rounded-2xl shadow-md p-16 text-center">

 <ChefHat className="w-20 h-20 text-gray-200 mx-auto mb-4" />

 <h3 className="text-xl font-bold text-gray-700">¡Cocina libre! </h3>

 <p className="text-gray-500 mt-2">No hay pedidos activos por ahora</p>

 <p className="text-gray-400 text-sm mt-1">Los nuevos pedidos aparecerán aquí automáticamente</p>

 </div>

 ) : (

 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">

 {sortedOrders.map((order, index) => (

 <KitchenCard

 key={order.id}

 order={order}

 orderIndex={order.kitchen_queue_position != null ? order.kitchen_queue_position : index}

 kitchenTimer={kitchenTimer}

 extraMinutes={extraMinutes}

 onMarkDone={handleMarkDone}

 onMarkCancelled={handleMarkCancelled}

 />

 ))}

 </div>

 )}



 {/* Pedidos Completados del día */}

 {doneOrders.length > 0 && (

 <div className="bg-white rounded-2xl shadow-md p-5">

 <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">

 <CheckCircle className="w-5 h-5 text-green-500" />

 Listos hoy ({doneOrders.length})

 </h3>

 <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">

 {doneOrders.map(order => {

 const items = Array.isArray(order.items) ? order.items : JSON.parse(order.items || '[]');

 const overtimeMins = order.overtime_seconds > 0 ? Math.ceil(order.overtime_seconds / 60) : 0;
 const doneCode = getOrderCode(order);

 return (

 <div key={order.id} className="bg-green-50 border border-green-200 rounded-xl p-3 text-center">

 <div className="text-lg font-black text-green-700">{doneCode}</div>

 <div className="text-xs text-green-600 mt-1">{formatEcuadorTime(order.created_at)}</div>

 <div className="text-xs text-gray-500 mt-1">{items.length} items</div>

 {overtimeMins > 0 && (

 <div className="text-xs text-orange-600 font-bold mt-1">+{overtimeMins} min</div>

 )}

 <div className="mt-1 text-xs font-bold text-green-500"> LISTO</div>

 </div>

 );

 })}

 </div>

 <button

 onClick={() => {

 setDoneOrders([]);

 localStorage.removeItem(`pos_done_orders_${todayStr}`);

 }}

 className="mt-3 text-xs text-gray-400 hover:text-gray-600 underline"

 >

 Limpiar historial

 </button>

 </div>

 )}

 </div>

 );

}



export default CocinaDisplay;

